import * as Yup from 'yup';
import { Contact, LegalAdviser, Participant } from '@models';
import { LegalAdviserType } from '@enums';

export function useValidationSchema() {
  return Yup.object<LegalAdviser>().shape({
    contact: Yup.mixed<Contact>().nullable().required(),
    clients: Yup.array<Participant>()
      .nullable()
      .when('legalAdviserType', {
        is: LegalAdviserType.OTHER,
        then: Yup.array<Participant>().nullable().notRequired(),
        otherwise: Yup.array<Participant>()
          .nullable()
          .min(1, 'Musí být vybrán alespoň 1 klient.')
          .required(),
      }),
  });
}
